//封装网络请求模块
import Vue from "vue";
import router from "../router";
import axios from "axios"
import { clearUserInfo } from '../utils'
import Qs from "qs"
import { Message } from 'element-ui'
let baseUrl = "https://shop-sk.xunyaogu.com/SKB2BApi/" // 请求接口路径
let baseImgUrl = "https://shop-sk.xunyaogu.com/SKB2BApi/" // 图片基础路径
let baseUrlServe = "https://shop-sk.xunyaogu.com/SKB2BApi/" // 请求接口正式路径

if (process.env.NODE_ENV == 'development') {
  baseUrlServe = "/mall" // 请求接口代理路径 
}

// axios.defaults.baseURL = baseUrlServe;
axios.defaults.timeout = 60000;

/**
 * 可以新建多个axios实例
 * 在项目使用多个请求地址时方便使用
 */
//导出第一个axios实例
function request(config) {
  let instence = axios.create({
    headers: {
      'Auth': window.localStorage.getItem('auth'),
      'ContentType': 'application/x-www-form-urlencoded'
    },
    baseURL: baseUrlServe,

    transformRequest: [function (data) {
      data = Qs.stringify(data)
      return data
    }],
  })
  instence.interceptors.request.use(function (res) {
    //请求开始
    //添加loading
    Vue.showLoading();
    // const token = store.getters.token
    // if (token) {
    //   config.headers.Authorization = token // 请求头部添加token
    // }
    return res
  }, function (err) {
    Vue.hideLoading();
    return err
  })
  instence.interceptors.response.use(function (res) {
    //响应成功
    //关闭loading
    Vue.hideLoading();
    if (res.data.flag && res.data.flag == 2) {
      clearUserInfo()
      Message({
        title: '提示',
        type: 'warning',
        message: '请先登录'
      })
      router.replace("/login?redirect='1'");
    } else if (res.data.return_code && res.data.return_code == 2) {
      clearUserInfo()
      router.replace("/login?redirect='1'");
    } else if (res.data.msgCode && res.data.msgCode == 'E003') {
      clearUserInfo()
      router.replace("/login?redirect='1'");
    } else if (res.data.msgCode && res.data.msgCode == '402') {
      // 登录超时
      clearUserInfo()
      router.replace("/login?redirect='1'");
    }
    return res.data
  }, function (err) {
    Vue.hideLoading();
    return err
  })
  return instence(config)
}

//新的axios实例，针对过程接口
function requestSys(config) {
  let urlStart = 'admin/'
  config.url = urlStart + config.url

  let instence = axios.create({
    headers: {
      'Auth': window.localStorage.getItem('auth'),
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    baseURL: baseUrlServe,
    transformRequest: [function (data) {
      data = Qs.stringify(data)
      return data
    }],
  })
  instence.interceptors.request.use(function (res) {
    //请求开始
    //添加loading
    Vue.showLoading();
    // const token = store.getters.token
    // if (token) {
    //   config.headers.Authorization = token // 请求头部添加token
    // }
    return res
  }, function (err) {
    Vue.hideLoading();
    return err
  })
  instence.interceptors.response.use(function (res) {
    //响应成功
    //关闭loading
    Vue.hideLoading();
    //状态等于1一般就是没有数据，没有加是因为有的接口不想让它显示
    // if (res.data.flag == 1) {
    //   Message({
    //     title: '提示',
    //     type: 'warning',
    //     message: res.data.message
    //   })
    // } else 
    if (res.data.flag == 2) {
      clearUserInfo()
      Message({
        title: '提示',
        type: 'warning',
        message: '请先登录'
      })
      router.replace("/login?redirect='1'");
    }
    //  else if (res.data.flag == 3) {
    //   //接口报错问题
    //   Message({
    //     title: '提示',
    //     type: 'error',
    //     message: res.data.message
    //   })
    // }
    return res.data
  }, function (err) {
    Vue.hideLoading();
    return err
  })
  return instence(config)
}

//上传文件时使用的请求实例
function uploadRequest(config) {
  // let urlStart = 'admin/'
  // config.url = urlStart + config.url
  let instence = axios.create({
    headers: {
      'Content-Type': 'multipart/form-data',
      'Auth': window.localStorage.getItem('auth')
    },
    baseURL: baseUrlServe,
  })
  instence.interceptors.request.use(function (res) {
    //请求开始
    //添加loading
    Vue.showLoading();
    return res
  }, function (err) {
    Vue.hideLoading();
    return err
  })
  instence.interceptors.response.use(function (res) {
    //响应成功
    //关闭loading
    Vue.hideLoading();
    if (res.data.flag == 2) {
      clearUserInfo()
      Message({
        title: '提示',
        type: 'warning',
        message: '请先登录'
      })
      router.replace("/login?redirect='1'");
    }
    return res.data
  }, function (err) {
    Vue.hideLoading();
    return err
  })
  return instence(config)
}


export {
  request,
  requestSys,
  baseUrl,
  baseImgUrl,
  baseUrlServe,
  uploadRequest
}